import React, { useState, useRef } from 'react';
import { applySpokenPunctuation } from '../data/spokenPunctuation';   // Record 661: "period", "comma", "question mark" ... become marks

// Reusable "talk to type" button. Calls onText(transcript) with each spoken phrase
// so the caller can append it to whatever field it belongs to.
// Uses the Web Speech API (Chrome, Android, Safari). Degrades gracefully elsewhere.
export default function DictationButton({ onText, compact }) {
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);

  const toggle = () => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) {
      alert('Voice typing needs Chrome — or use the microphone button on your device keyboard.');
      return;
    }
    if (listening) {
      try { recRef.current && recRef.current.stop(); } catch (e) {}
      setListening(false);
      return;
    }
    const rec = new SR();
    rec.continuous = true;
    rec.interimResults = false;
    rec.lang = 'en-US';
    rec.onresult = (e) => {
      let t = '';
      for (let i = e.resultIndex; i < e.results.length; i++) t += e.results[i][0].transcript;
      t = applySpokenPunctuation(t);
      if (t && onText) onText(t);
    };
    rec.onend = () => setListening(false);
    rec.onerror = () => setListening(false);
    recRef.current = rec;
    try { rec.start(); setListening(true); } catch (e) { setListening(false); }
  };

  return (
    <button type="button" onClick={toggle} title={listening ? 'Stop voice typing' : 'Talk to type'}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        padding: compact ? '2px 8px' : '6px 12px',
        borderRadius: 6, fontSize: compact ? 11 : 12, fontWeight: 700, cursor: 'pointer',
        border: `1px solid ${listening ? '#C0392B' : '#2E4A6B'}`,
        background: listening ? '#2D0A0A' : '#0D1B2A',
        color: listening ? '#FF6B6B' : '#8AA4BF',
      }}>
      {listening ? '● Stop' : (compact ? '🎤' : '🎤 Talk to type')}
    </button>
  );
}
